import { render, staticRenderFns } from "./PermissionListComponent.vue?vue&type=template&id=75f5c50d&"
import script from "./PermissionListComponent.vue?vue&type=script&lang=js&"
export * from "./PermissionListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f5c50d')) {
      api.createRecord('75f5c50d', component.options)
    } else {
      api.reload('75f5c50d', component.options)
    }
    module.hot.accept("./PermissionListComponent.vue?vue&type=template&id=75f5c50d&", function () {
      api.rerender('75f5c50d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/permission-list/components/PermissionListComponent.vue"
export default component.exports